module.exports = __webpack_public_path__ + "static/media/26UNRWA5.6db8e416.jpg";